/* Runs a standalone document's own scripts, in source order, against the
 * markup React has already put on the page. External sources are awaited so a
 * library (d3 for Humaine) is defined before the code that uses it runs.
 * Injected markup never executes its own <script> tags, which is why the build
 * scripts split them out. Returns a function that stops any still pending. */
export default function runDocScripts(scripts, container, label = "Document") {
  let cancelled = false;

  const next = index => {
    if (cancelled || index >= scripts.length) return;
    const spec = scripts[index];
    const el = document.createElement("script");

    if (spec.src) {
      el.src = spec.src;
      el.async = false;
      el.onload = () => next(index + 1);
      el.onerror = () => {
        console.error(`${label}: failed to load`, spec.src);
        next(index + 1);
      };
      container.appendChild(el);
      return;
    }

    el.text = spec.code;
    try {
      container.appendChild(el);
    } catch (e) {
      console.error(`${label}: script failed`, e);
    }
    next(index + 1);
  };

  next(0);
  return () => {
    cancelled = true;
  };
}
